export default "__VITE_ASSET__ClJq46tF__"